// extracted by mini-css-extract-plugin
module.exports = {"cascaderPopup":"company-info_cascaderPopup__lgIjo","container":"company-info_container__4fPeu","form":"company-info_form__iJ48U","submitBtn":"company-info_submitBtn__PIHbd"};